import React, { useEffect, useState } from "react";
import Hero from "./sections/Hero";
import RecommendedTopics from "./sections/RecommendedTopics";
import CoursesCarousel from "../../components/utils/CoursesCarousel";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import color from "../../components/utils/Colors";
import { Close, Done } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "../../services/axiosClient";
import {
  getDataFromTable,
  getOpenDataFromTable,
} from "../../services/services";
import { useSnackbar } from "../../components/utils/SnackBar";
import { useUser } from "../../services/Context/UserContext";
export default function Home() {
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const { user } = useUser();

  const [course, setCourse] = useState<any[]>([]);
  const [ratingsMap, setRatingsMap] = useState<
    Record<number, { local: number; global: number }>
  >({});

  useEffect(() => {
    getDataFromTable("course", { status: "published" })
      .then((result) => {
        const courses = result?.data?.data || [];
        setCourse(courses);

        if (courses.length === 0) return;

        // Fetch all ratings in ONE call (adjust filter key as per your API)
        getDataFromTable("userRatings", {})
          .then((res: any) => {
            const allRatings: any[] = res?.data?.data || [];

            const map: Record<number, { local: number; global: number }> = {};

            courses.forEach((c: any) => {
              const feedbackType = `course_${c.id}`;
              const relevant = allRatings.filter(
                (r) => r.feedbackType === feedbackType,
              );

              const globalAvg =
                relevant.length > 0
                  ? relevant.reduce(
                      (sum: number, r: any) => sum + (r.rating || 0),
                      0,
                    ) / relevant.length
                  : 0;

              const userRating = user?.id
                ? relevant.find((r) => r.userId === user.id)?.rating || 0
                : 0;

              map[c.id] = { local: userRating, global: globalAvg };
            });

            setRatingsMap(map);
          })
          .catch(console.error);
      })
      .catch((error) => {
        const msg = error?.response?.data?.message || error?.response?.data?.msg;
        if (msg) showSnackbar(msg);
      });
  }, [user?.id]);

  const coursesWithRatings = course.map((c) => ({
    ...c,
    localRating: ratingsMap[c.id]?.local ?? 0,
    globalRating: ratingsMap[c.id]?.global ?? 0,
  }));
  return (
    <Box sx={{ paddingBottom: 10 }}>
      <Hero />
      <CoursesCarousel
        title="Because You View : Physics"
        courses={coursesWithRatings}
      />
      <CoursesCarousel
        title="Students Are Viewing"
        courses={coursesWithRatings}
      />
      <CoursesCarousel
        title="Recommended Courses"
        courses={coursesWithRatings}
      />
      <CoursesCarousel
        title="Top Courses in Design"
        courses={coursesWithRatings}
      />
    </Box>
  );
}
